/* ════════════════════════════════════════════════
   RAIMENT MEDIA — theme.js
   Vanilla, dependency-free. Native Shopify AJAX cart.
════════════════════════════════════════════════ */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  /* ── Money formatting (mirrors Shopify's option_selection.js) ── */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var match = moneyFormat.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      default: value = defaultTo(cents, 2);
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ════════════════════════════════
     TOAST
  ════════════════════════════════ */
  var toastTimer;
  function toast(message) {
    var el = $('#ToastRegion');
    if (!el) return;
    el.textContent = '✓ ' + message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 1800);
  }

  /* ════════════════════════════════
     CART
  ════════════════════════════════ */
  var Cart = {
    open: function () {
      var drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
      if (!drawer) return;
      overlay && overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
      overlay && overlay.classList.remove('is-open');
      drawer && drawer.classList.remove('is-open');
      drawer && drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    add: function (id, quantity, button) {
      if (!id) { toast('Select a size first'); return; }
      var label = button && button.textContent;
      if (button) { button.disabled = true; button.dataset.loading = '1'; button.textContent = '…'; }
      fetch((routes.cart_add || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (button) { button.disabled = false; delete button.dataset.loading; if (label) button.textContent = label; }
          if (!res.ok) { toast((res.data && res.data.description) || 'Could not add'); return; }
          toast(strings.addedToCart || 'Added to cart');
          return Cart.refresh(true);
        })
        .catch(function () {
          if (button) { button.disabled = false; if (label) button.textContent = label; }
          toast('Network error');
        });
    },
    refresh: function (openAfter) {
      return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Cart.render(cart);
          Cart.updateCount(cart.item_count);
          if (openAfter) Cart.open();
          return cart;
        });
    },
    updateCount: function (count) {
      $all('[data-cart-count]').forEach(function (el) { el.textContent = '[' + count + ']'; });
      // Visible header badge: show only when items exist
      $all('[data-cart-count-badge]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      // Insert a badge if the header rendered without one (cart was empty on load)
      if (count > 0) {
        $all('.nav__cart').forEach(function (cartEl) {
          if (!cartEl.querySelector('[data-cart-count-badge]')) {
            var badge = document.createElement('span');
            badge.className = 'nav__cart-count';
            badge.setAttribute('data-cart-count-badge', '');
            badge.textContent = count;
            cartEl.insertBefore(badge, cartEl.firstChild);
          }
        });
      }
    },
    changeQty: function (line, qty) {
      fetch((routes.cart_change || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); Cart.updateCount(cart.item_count); });
    },
    render: function (cart) {
      var body = $('#CartDrawerBody');
      if (!body) return;
      var freeBar = body.getAttribute('data-free-shipping') === 'true';
      if (!cart.item_count) {
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<div class="cart-drawer__empty-text">' + (strings.cartEmpty || 'Your cart is empty') + '</div>' +
          '<a class="btn-primary" href="' + (body.getAttribute('data-continue-url') || '/') + '">Browse the collection</a>' +
          '</div>';
        return;
      }
      var items = cart.items.map(function (item, i) {
        var img = item.image
          ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">'
          : '';
        var opts = item.options_with_values
          ? item.options_with_values.map(function (o) { return o.value; }).filter(function (v) { return v !== 'Default Title'; }).join(' · ')
          : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
        return (
          '<div class="cart-line" data-line="' + (i + 1) + '">' +
          '<div class="cart-line__media">' + img + '</div>' +
          '<div class="cart-line__info">' +
          '<div class="cart-line__name">' + item.product_title + '</div>' +
          (opts ? '<div class="cart-line__variant">' + opts + '</div>' : '') +
          '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cart-line__qty">' +
          '<button type="button" data-qty-down aria-label="Decrease">–</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty-up aria-label="Increase">+</button>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-remove>Remove</button>' +
          '</div></div>'
        );
      }).join('');

      body.innerHTML =
        (freeBar ? '<div class="cart-drawer__ship">Free shipping unlocked ✓</div>' : '') +
        items +
        '<div class="cart-drawer__foot">' +
        '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<div class="cart-drawer__note">✓ Free worldwide delivery · surprise gift in every order</div>' +
        '<a class="cart-drawer__checkout" href="/checkout">Checkout — ' + formatMoney(cart.total_price) + '</a>' +
        '</div>';
    }
  };
  window.RaimentCart = Cart;

  /* ════════════════════════════════
     PRODUCT — variant / size selection
  ════════════════════════════════ */
  function selectVariant(btn) {
    if (!btn || btn.classList.contains('is-sold-out')) return;
    var form = btn.closest('[data-product-form]');
    if (!form) return;
    $all('.size-btn', form).forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-checked', 'true');

    var id = btn.getAttribute('data-variant-id');
    var input = $('[name="id"]', form);
    if (input && id) input.value = id;

    var price = btn.getAttribute('data-price');
    if (price) $all('[data-price-target]').forEach(function (el) { el.textContent = price; });

    var sizeLabel = btn.getAttribute('data-size') || btn.textContent.trim();
    $all('[data-selected-size]').forEach(function (el) { el.textContent = sizeLabel; });

    var available = btn.getAttribute('data-available') !== 'false';
    $all('[data-atc]', form).forEach(function (atc) {
      atc.disabled = !available;
      var lbl = atc.querySelector('[data-atc-label]');
      if (lbl) lbl.textContent = available ? (atc.getAttribute('data-add-label') || 'Add to cart') : (strings.soldOut || 'Sold out');
    });
  }

  /* ── Gallery thumb swap ── */
  function swapGallery(thumb) {
    var full = thumb.getAttribute('data-full');
    var main = $('#ProductMainImage');
    if (full && main) { main.src = full; main.srcset = ''; }
    var label = thumb.getAttribute('data-label');
    var tag = $('#ProductMainTag');
    if (tag && label) tag.textContent = label;
    $all('.product__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  /* ════════════════════════════════
     BUNDLE / CROSS-SELL ("complete the trio")
  ════════════════════════════════ */
  function recomputeBundle(bundle) {
    if (!bundle) return;
    var base = parseInt(bundle.getAttribute('data-base-price'), 10) || 0;
    var total = base, count = 1;
    $all('[data-bundle-variant]', bundle).forEach(function (cb) {
      if (cb.checked) { total += parseInt(cb.getAttribute('data-bundle-price'), 10) || 0; count++; }
    });
    var totalEl = bundle.querySelector('[data-bundle-total]');
    var countEl = bundle.querySelector('[data-bundle-count]');
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (countEl) countEl.textContent = count;
  }

  function addBundle(button) {
    var bundle = button.closest('[data-bundle]');
    if (!bundle) return;
    var ids = [{ id: button.getAttribute('data-base-variant'), quantity: 1 }];
    $all('[data-bundle-variant]', bundle).forEach(function (cb) {
      if (cb.checked) ids.push({ id: cb.getAttribute('data-bundle-variant'), quantity: 1 });
    });
    button.disabled = true;
    fetch((routes.cart_add || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids })
    })
      .then(function (r) { return r.json(); })
      .then(function () { button.disabled = false; toast('Bundle added'); return Cart.refresh(true); })
      .catch(function () { button.disabled = false; toast('Network error'); });
  }

  /* ════════════════════════════════
     STICKY ADD-TO-CART
  ════════════════════════════════ */
  function initStickyATC() {
    var sticky = $('[data-sticky-atc]');
    var sentinel = $('[data-atc-sentinel]');
    if (!sticky || !sentinel || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // show the bar once the main ATC has scrolled out of view upward
        if (!e.isIntersecting && e.boundingClientRect.top < 0) {
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        } else {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0 });
    observer.observe(sentinel);
  }

  /* ════════════════════════════════
     COUNTDOWN ("order in HH:MM:SS posted today")
  ════════════════════════════════ */
  function initCountdown() {
    var els = $all('[data-countdown]');
    if (!els.length) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(17, 0, 0, 0);
      var diff = end - now; if (diff < 0) diff += 86400000;
      var h = Math.floor(diff / 3.6e6), m = Math.floor((diff % 3.6e6) / 6e4), s = Math.floor((diff % 6e4) / 1000);
      var str = pad(h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function (el) { el.textContent = str; });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ════════════════════════════════
     PRODUCT RECOMMENDATIONS (Search & Discovery)
  ════════════════════════════════ */
  function initRecommendations() {
    var el = $('[data-recommendations]');
    if (!el) return;
    var sectionId = el.getAttribute('data-section-id');
    var productId = el.getAttribute('data-product-id');
    var limit = el.getAttribute('data-limit') || 3;
    if (!sectionId || !productId) return;
    var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
              '&product_id=' + encodeURIComponent(productId) + '&limit=' + limit;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var fresh = tmp.querySelector('.related-products');
        if (fresh && fresh.querySelector('.product-card')) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          if (document.body.classList.contains('anim-on')) el.classList.add('is-in');
        }
      })
      .catch(function () { /* leave hidden */ });
  }

  /* ════════════════════════════════
     SCROLL-IN ANIMATIONS
  ════════════════════════════════ */
  function initAnimations() {
    if (!document.body.classList.contains('anim-on')) return;
    var nodes = $all('[data-animate]');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    nodes.forEach(function (el) { io.observe(el); });
  }

  /* ════════════════════════════════
     DELEGATED EVENTS
  ════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var sizeBtn = t.closest('.size-btn');
    if (sizeBtn) { e.preventDefault(); selectVariant(sizeBtn); return; }

    var thumb = t.closest('.product__thumb');
    if (thumb) { e.preventDefault(); swapGallery(thumb); return; }

    var bundleAdd = t.closest('[data-bundle-add]');
    if (bundleAdd) { e.preventDefault(); addBundle(bundleAdd); return; }

    var atc = t.closest('[data-atc]');
    if (atc) {
      e.preventDefault();
      var form = atc.closest('[data-product-form]');
      var input = form && $('[name="id"]', form);
      Cart.add(input && input.value, 1, atc);
      return;
    }

    if (t.closest('[data-cart-open]')) {
      e.preventDefault();
      if (document.body.getAttribute('data-cart-type') === 'page') { window.location.href = routes.cart_url || '/cart'; return; }
      Cart.refresh(true);
      return;
    }
    if (t.closest('[data-cart-close]') || t.id === 'CartOverlay') { e.preventDefault(); Cart.close(); return; }

    var qtyUp = t.closest('[data-qty-up]'), qtyDown = t.closest('[data-qty-down]'), remove = t.closest('[data-remove]');
    if (qtyUp || qtyDown || remove) {
      var line = t.closest('[data-line]');
      if (!line) return;
      var idx = parseInt(line.getAttribute('data-line'), 10);
      var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
      if (remove) Cart.changeQty(idx, 0);
      else Cart.changeQty(idx, qtyUp ? current + 1 : Math.max(0, current - 1));
      return;
    }

    if (t.closest('[data-size-guide-open]')) { e.preventDefault(); var sg = $('#SizeGuide'); if (sg) { sg.classList.add('is-open'); sg.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } return; }
    if (t.closest('[data-size-guide-close]') || t.id === 'SizeGuide') { e.preventDefault(); var sg2 = $('#SizeGuide'); if (sg2) { sg2.classList.remove('is-open'); sg2.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } return; }
    var dialog = t.closest('.modal__dialog'); if (dialog) e.stopPropagation();

    var faqTrigger = t.closest('.faq-item__trigger');
    if (faqTrigger) {
      var faqItem = faqTrigger.closest('.faq-item');
      var faqOpen = faqItem.classList.contains('is-open');
      // Close siblings (one open at a time)
      var list = faqItem.closest('.faq__list');
      if (list) $all('.faq-item', list).forEach(function (it) { it.classList.remove('is-open'); var b = it.querySelector('.faq-item__trigger'); if (b) b.setAttribute('aria-expanded', 'false'); });
      if (!faqOpen) { faqItem.classList.add('is-open'); faqTrigger.setAttribute('aria-expanded', 'true'); }
      return;
    }

    var acc = t.closest('.accordion__trigger');
    if (acc) {
      var item = acc.closest('.accordion__item');
      var isOpen = item.classList.contains('is-open');
      var span = acc.querySelector('span');
      item.classList.toggle('is-open');
      acc.setAttribute('aria-expanded', String(!isOpen));
      if (span) span.textContent = isOpen ? '+' : '–';
      return;
    }

    if (t.closest('[data-menu-open]')) { e.preventDefault(); var md = $('#MenuDrawer'), mo = $('#MenuOverlay'); md && md.setAttribute('aria-hidden', 'false'); mo && mo.classList.add('is-open'); document.body.style.overflow = 'hidden'; return; }
    if (t.closest('[data-menu-close]') || t.id === 'MenuOverlay') { e.preventDefault(); var md2 = $('#MenuDrawer'), mo2 = $('#MenuOverlay'); md2 && md2.setAttribute('aria-hidden', 'true'); mo2 && mo2.classList.remove('is-open'); document.body.style.overflow = ''; return; }
  });

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-bundle-variant]');
    if (cb) {
      var row = cb.closest('[data-bundle-row]');
      if (row) row.classList.toggle('is-on', cb.checked);
      var check = row && row.querySelector('.bundle__check');
      if (check) check.textContent = cb.checked ? '✓' : '';
      recomputeBundle(cb.closest('[data-bundle]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Cart.close();
      var sg = $('#SizeGuide'); if (sg) { sg.classList.remove('is-open'); sg.setAttribute('aria-hidden', 'true'); }
      var md = $('#MenuDrawer'); if (md) md.setAttribute('aria-hidden', 'true');
      var mo = $('#MenuOverlay'); if (mo) mo.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ── Header height var for sticky offsets ── */
  function setHeaderHeight() {
    var header = $('.site-header');
    if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  document.addEventListener('DOMContentLoaded', function () {
    setHeaderHeight();
    initStickyATC();
    initRecommendations();
    initAnimations();
    Cart.refresh(false);
    var preselect = $('.size-btn.is-selected');
    // keep server-rendered selection; nothing to do
  });
  window.addEventListener('resize', setHeaderHeight);
})();
